(function ($) {

        $(document).ready(function () {

            if ($('.tbd.image-text-slider').length > 0) {
                setTimeout(function () {
                    $(".tbd.image-text-slider .row-wrapper").css({"opacity": "1"});
                }, 500);

                $('.tbd.image-text-slider .row-wrapper').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: false,
                    cssEase: 'linear',
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                draggable: true
                            }
                        }
                    ]
                });
            }

        });

})(jQuery);